/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function NoteIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M10 9c-.562 0-1 .5-1 1v20c0 .563.438 1 1 1h14v-5c0-1.062.875-2 2-2h5V10c0-.5-.5-1-1-1zm14 25H10c-2.25 0-4-1.75-4-4V10c0-2.187 1.75-4 4-4h20c2.188 0 4 1.813 4 4v14.375a3.98 3.98 0 0 1-1.187 2.813l-5.688 5.687c-.75.75-1.75 1.125-2.812 1.125z"/>}
        </IconWrapper>);
}
